module.exports = __webpack_public_path__ + "img/warning.36fae9e7.svg";